<template>
  <div class="hello" ref="pageSizeFlag">
    <div class="home_top">
      <div class="shop_name">
        <img src="../assets/static/shopName.png" alt style="width: 154px;" />
      </div>
      <div class="shop_type">
        <div
          v-for="item in menuList"
          :key="item.id"
          class="type_name"
          @click="menuChage(item)"
          :class="menuIndex == item.id ? 'menu_change' : ''"
        >
          <div>{{ item.name }}</div>
          <img src="../assets/static/menuBG.png" alt class="mentbg" v-if="menuIndex == item.id" />
          <div v-if="menuIndex == item.id && menuIndex == 4  && menuOrderFlag" class="ment_table">
            <div
              v-for="item in menuOrderList"
              :key="item.id"
              @click.stop="orderChange(item,1)"
              :class="ordertype == item.id ? 'menu_order_change': ''"
            >{{ item.title }}</div>
          </div>
          <div v-if="menuIndex == item.id && menuIndex == 5 &&  menuUserFlag" class="ment_table">
            <div
              v-for="item in menuUserList"
              :key="item.id"
              @click.stop="orderChange(item,2)"
              :class="usertype == item.id ? 'menu_order_change': ''"
            >{{ item.title }}</div>
          </div>
        </div>
      </div>
      <div class="shop_user">
        <img src="../assets/static/user.png" class="user_left" style="margin-right: 8px;" />
        <div v-if="dialogVisibleRegistert" @click="goLogin">去登录</div>
        <el-dropdown @command="handleCommand" v-else>
          <span class="el-dropdown-link">
            {{statusRight.nickname}}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="a">
              在线
              <i class="el-icon-check" v-if="statusRight.is_online == 1"></i>
            </el-dropdown-item>
            <el-dropdown-item command="b">
              离线
              <i class="el-icon-check" v-if="statusRight.is_online == 0"></i>
            </el-dropdown-item>
            <el-dropdown-item command="c">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <!-- <img src="../assets/static/dropDown.png" class="user_left" /> -->
      </div>
    </div>
    <realTimeMonitoring
      v-if="menuIndex == 1"
      ref="realTimeMonitoringRef"
      :storeId="storeIdLog"
      @changeMenu="changeMenu"
      @clickVideoReplay="videoReplay"
      @lookLog="lookLog"
      @goOrderDetail="goOrderDetail"
      @getToken="getToken"
    ></realTimeMonitoring>
    <!-- ordertype != -1 -->
    <orderList
      v-if="menuIndex == 4"
      ref="orderListRef"
      :typeOeder="ordertype"
      :roomId="roomId"
      :orderDetailId="orderDetailId"
      @clickVideoReplay="videoReplay"
      @getToken="getToken"
    ></orderList>
    <!-- && usertype != -1 -->
    <userList v-if="menuIndex == 5" ref="userListRef" :typeUser="usertype" @getToken="getToken"></userList>
    <logRecording
      v-if="menuIndex == 3"
      ref="logRecordingRef"
      :storeId="storeIdLog"
      @clickVideoReplay="videoReplay"
      @getToken="getToken"
    ></logRecording>
    <billManagement v-if="menuIndex == 2" ref="billManagementref" @getToken="getToken"></billManagement>
    <el-dialog
      title="视频回放"
      :visible.sync="dialogVisibleTakeout"
      width="66%"
      :before-close="handleClose"
    >
      <div class="video_replay over_flow_style" :style="{height: (pageSizeHeight + 48) + 'px'}">
        <div
          v-for="item in monitorInfoList"
          :key="item.id"
          style="margin-right: 10px;"
          :style="{width: item.widthNo + 'px',height: (item.heightNo + 50) + 'px'}"
        >
          <!-- :style="{width: item.widthNo + 'px',height: item.heightNo + 'px'}" -->
          <video
            :id="item.characteristic"
            class="video_item"
            controls
            :src="item.live_path"
            :width="item.widthNo + 'px'"
            :height="item.heightNo + 'px'"
          ></video>
          <div class="video_name">{{ item.name }}</div>
        </div>
        <!-- <div v-for="item in monitorInfoList" :key="item.id" style="margin-right: 10px;margin-bottom: 10px">
          <div :id="item.characteristic" v-if="item.equipmentNo == 2"></div>
          <div
            v-else
            :style="{width: item.widthNo + 'px',height: item.heightNo + 'px'}"
            class="no_monitor"
          >设备不在线，请检查网络</div>
          <div class="monitor_function">
            <div>大门</div>
            <div>
              <img
                src="../assets/static/soundClose.png"
                alt
                style="width: 24px;;margin-right: 20px"
                v-if="item.talk == 2"
                @click="talkChange(item,2)"
              />
              <img
                src="../assets/static/soundOpen.png"
                alt
                style="width: 24px;;margin-right: 20px"
                v-if="item.talk == 1"
                @click="talkChange(item,1)"
              />
              <img
                src="../assets/static/wnlarge.png"
                alt
                style="width: 24px;"
                @click="wnlargeChange(item)"
              />
            </div>
          </div>
        </div>-->
      </div>
    </el-dialog>
    <el-dialog
      title
      :visible.sync="dialogVisibleRegistert"
      width="30%"
      :before-close="handleClose"
      custom-class="custom_class"
      :show-close="false"
      center
    >
      <div class="registert_title">登录</div>
      <el-form ref="form" :model="form">
        <el-form-item>
          <el-input v-model="form.username" placeholder="请输入账号" prefix-icon="el-icon-user"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            show-password
            v-model="form.password"
            placeholder="请输入密码"
            prefix-icon="el-icon-lock"
          ></el-input>
        </el-form-item>
        <div style="width: 100%;text-align: center;">
          <el-button type="primary" @click="onSubmit" style="width: 60%;">登录</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import EZUIKit from "ezuikit-js";
import realTimeMonitoring from "./realTimeMonitoring.vue";
import orderList from "./orderList.vue";
import userList from "./userList.vue";
import logRecording from "./logRecording.vue";
import billManagement from "./billManagement.vue";
import { VideoPlayback } from "@/utils/api/index";
import { AdminUser, signOut, setOnline, getInfoRight } from "@/utils/api/index";
import { Message } from "element-ui";
export default {
  name: "HelloWorld",
  components: {
    realTimeMonitoring,
    orderList,
    userList,
    logRecording,
    billManagement
  },
  data() {
    return {
      form: {
        password: "",
        username: ""
      },
      dialogVisibleRegistert: false,
      storeIdLog: "",
      roomId: "",
      dialogVisibleTakeout: false,
      monitorInfoList: [],
      pageSizeHeight: 0,
      menuList: [
        {
          id: 1,
          name: "实时监控"
        },
        {
          id: 2,
          name: "账单统计"
        },
        {
          id: 3,
          name: "日志记录"
        },
        {
          id: 4,
          name: "订单管理"
        },
        {
          id: 5,
          name: "用户列表"
        }
      ],
      menuOrderList: [
        {
          id: 1,
          title: "稽查标记"
        },
        {
          id: 2,
          title: "订单查询"
        }
      ],
      menuUserList: [
        {
          id: 1,
          title: "用户列表"
        },
        {
          id: 3,
          title: "骑手列表"
        },
        {
          id: 2,
          title: "黑名单"
        }
      ],
      menuIndex: 1,
      shopList: [],
      ordertype: -1,
      usertype: -1,
      menuOrderFlag: false,
      menuUserFlag: -1,
      orderDetailId: "",
      // token: "",
      statusRight: {}
    };
  },
  created() {},
  mounted() {
    // const paramValue = this.$route; // 'paramName'是你想要获取的参数名
    // console.log(paramValue.query.token, "this.$route获取参数");
    // let tokenTemp;
    // if (paramValue.query.token) {
    //   tokenTemp = localStorage.setItem("token", paramValue.query.token);
    // } else if (localStorage.getItem("token")) {
    //   tokenTemp = localStorage.getItem("token");
    // }
    // this.token = tokenTemp;
    // console.log(
    //   localStorage.getItem("login") == "1",
    //   "this.tokenthis.tokenthis.tokenthis.token"
    // );
    // if (
    //   !this.token ||
    //   this.token == "undefined" ||
    //   localStorage.getItem("login") == "1"
    // ) {
    //   this.dialogVisibleRegistert = true;
    // }
    this.getName();
    const div = this.$refs.pageSizeFlag;
    const height = div.offsetHeight * 0.7;
    this.pageSizeHeight = height;
  },
  computed: {
    token() {
      const paramValue = this.$route;
      let tokenTemp;
      if (paramValue.query.token) {
        console.log('888888888',paramValue.query.token)
        localStorage.setItem("token", paramValue.query.token);
        tokenTemp = paramValue.query.token
        console.log('888888888',localStorage.getItem("token"))
        
      } else if (localStorage.getItem("token")) {
        tokenTemp = localStorage.getItem("token");
      }
      console.log(tokenTemp,'tokenTemptokenTemp')
      return tokenTemp;
    },
    loginFlag() {
      return localStorage.getItem('login');
    },
  },
  watch: {
    token: {
      handler() {
        // console.log(this.token,!this.token,'!this.toke1')
        // console.log(this.token == "undefined",'this.token == "undefined"1')
        // console.log(localStorage.getItem("login"),localStorage.getItem("login") == "1",'!this.token1')
        if (
          !this.token ||
          this.token == "undefined" ||
          localStorage.getItem("login") == "1"
        ) {
          this.dialogVisibleRegistert = true;
        } else {
          this.dialogVisibleRegistert = false;

        }
      },
      deep: true,
      immediate: true
    },
    loginFlag: {
      handler() {
        console.log(this.token,!this.token,'!this.toke2')
        console.log(this.token == "undefined",'this.token == "undefined"2')
        console.log(localStorage.getItem("login"),localStorage.getItem("login") == "1",'!this.token2')
        if (
          !this.token ||
          this.token == "undefined" ||
          localStorage.getItem("login") == "1"
        ) {
          this.dialogVisibleRegistert = true;
        }else {
          this.dialogVisibleRegistert = false;

        }
      },
      deep: true,
      immediate: true
    },
  },
  methods: {
    getToken() {},
    getName() {
      if (this.token) {
        getInfoRight({}).then(res => {
          this.statusRight = res.data;
          console.log(res, "ppppppppppppppp");
        });
      }
    },
    handleCommand(command) {
      if (command == "c") {
        signOut({}).then(res => {
          localStorage.removeItem("token");
          // localStorage.setItem('token',undefined)
          this.token = undefined;
          this.dialogVisibleRegistert = true;
          Message({
            message: res.message,
            type: "success"
          });
          this.form = {
            nickname: "",
            password: ""
          };
          this.getListChild();
        });
      } else {
        setOnline({
          is_online: command == "a" ? 1 : 0
        }).then(res => {
          console.log("状态", res);
          Message({
            message: res.message,
            type: "success"
          });
          this.getName();
        });
      }
    },
    goLogin() {
      this.dialogVisibleRegistert = true;
    },
    onSubmit() {
      AdminUser({
        username: this.form.username,
        password: this.form.password
      }).then(res => {
        // this.optionsMobile = res.data;
        console.log("rrrrr", res);
        if (res.code == 200) {
          localStorage.setItem("token", res.data.access_token);
          this.token = res.data.access_token;
          this.getName();
          this.getListChild();
          this.dialogVisibleRegistert = false;
        } else {
          Message({
            message: res.msg,
            type: "error"
          });
        }
      });
    },
    getListChild() {
      if (this.menuIndex == 1) {
        this.$refs.realTimeMonitoringRef.getMonitirCenter();
        this.$refs.realTimeMonitoringRef.getShop();
        this.$refs.realTimeMonitoringRef.destroyOut();
      }
      if (this.menuIndex == 2) {
        this.$refs.billManagementref.getRoomList();
        this.$refs.billManagementref.getList(1);
      }
      if (this.menuIndex == 3) {
        this.$refs.logRecordingRef.getData(1);
      }
      if (this.menuIndex == 4) {
        this.$refs.orderListRef.getRoomList(1);
        this.$refs.orderListRef.getUserMobile();
      }
      if (this.menuIndex == 5) {
        this.$refs.userListRef.getList(1);
        this.$refs.userListRef.getUserMobile();
      }
    },
    talkChange(item, type) {
      if (type == 1) {
        item.player.stopTalk();
        item.talk = 2;
      }
      if (type == 2) {
        item.player.startTalk();
        item.talk = 1;
      }
    },
    wnlargeChange(item) {
      item.player.fullScreen();
    },
    lookLog(storeIdLog) {
      this.menuIndex = 3;
      this.storeIdLog = storeIdLog;
    },
    goOrderDetail(info) {
      console.log(info, "infoinfo");
      if (info.type == 3) {
        this.menuIndex = 4;
        this.ordertype = 2;
        this.orderDetailId = info.order_id;
      }
    },
    async videoReplay(e) {
      // e type 1表示外卖订单 2表示日志管理 3 订单管理
      console.log(e, "ppppppppppp");
      let id;
      if (e.type === 1) {
        id = e.row.id;
      }
      if (e.type === 2) {
        id = e.row.order_id;
      }
      if (e.type === 3) {
        id = e.row.id;
      }
      console.log(e.row.id, e.type == 1);

      await VideoPlayback({
        id: id
      }).then(res => {
        let id = "videoReplay";
        let index = 1;
        console.log(res.data, "res.datares.datares.data");
        if (res.data.video_list.length == 0) {
          this.$message.error("暂无回放视频");
          return;
        }
        this.dialogVisibleTakeout = true;
        this.monitorInfoList = res.data.video_list.map(item => {
          const div = this.$refs.pageSizeFlag;
          const width = div.offsetWidth * 0.8 * 0.8;
          item.widthNo = width / 2 - 30;
          item.heightNo = this.pageSizeHeight / 2 - 50;
          // if (item.live_path == "") {
          //   const div = this.$refs.pageSizeFlag;
          //   const width = div.offsetWidth * 0.8 * 0.8;
          //   item.equipmentNo = 1;
          //   item.widthNo = width / 2 - 30;
          //   item.heightNo = this.pageSizeHeight / 2 - 50;
          // } else {
          //   item.equipmentNo = 2;
          // }
          item.characteristic = id + index;
          index++;
          item.talk = 2;
          return item;
        });
      });
      // this.getList();
    },
    getList() {
      this.$nextTick(() => {
        const div = this.$refs.pageSizeFlag;
        const width = div.offsetWidth * 0.8 * 0.8;
        this.monitorInfoList.forEach(item => {
          if (item.live_path != "") {
            item.player = new EZUIKit.EZUIKitPlayer({
              id: item.characteristic, // 视频容器ID
              width: width / 2 - 30,
              height: this.pageSizeHeight / 2 - 50,
              accessToken: item.accessToken,
              url: item.live_path,
              autoPlay: false,
              audio: false
            });
          }
        });
      });
    },
    handleClose() {
      this.dialogVisibleTakeout = false;
      this.monitorInfoList.forEach(item => {
        let play = document.getElementById(item.characteristic);
        play.pause();
      });
    },
    changeMenu(item) {
      console.log(item);
      this.roomId = item.id;
      this.menuIndex = 4;
      this.ordertype = 1;
    },
    menuChage(item) {
      this.menuIndex = item.id;
      if (item.id == 4) {
        this.menuOrderFlag = true;
        this.ordertype = -1;
      }
      if (item.id == 5) {
        this.menuUserFlag = true;
        this.usertype = -1;
      } else {
        this.ordertype = -1;
        this.usertype = -1;
      }
    },
    orderChange(item, type) {
      this.$nextTick(() => {
        if (type == 1) {
          this.menuOrderFlag = false;
          this.ordertype = item.id;
          console.log(this.ordertype);
        }
        if (type == 2) {
          this.menuUserFlag = false;
          this.usertype = item.id;
        }
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.el-dropdown {
  font-weight: 400;
  font-size: 20px;
  color: #ffffff;
}

.hello {
  background: #051238;
  height: 100vh;
  // min-width: 1920px;
}
.home_top {
  height: 54px;
  width: 100%;
  background: linear-gradient(128deg, #1261a6 0%, #0c3d85 100%);
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  .shop_name {
    width: 16%;
    margin: auto;
    margin-left: 30px;
  }
  .shop_type {
    width: 71%;
    height: 100%;
    display: flex;
    align-items: center;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: #d4e6ff;
    .type_name {
      position: relative;
      width: 172px;
      height: 54px;
      line-height: 54px;
      text-align: center;
      cursor: pointer;

      .mentbg {
        position: absolute;
        left: 0;
        bottom: -8px;
        width: 172px;
        height: 24px;
      }
      .ment_table {
        background-image: url(../assets/static/popVoice.png);
        background-repeat: no-repeat;
        background-position: center center;
        background-size: 100% 100%;
        font-size: 16px;
        color: #ffffff;
        margin-top: 12px;
        line-height: 37px;
        padding-top: 12px;
        z-index: 999;
        .menu_order_change {
          background: #ff901d;
        }
      }
    }
    .menu_change {
      font-size: 24px;
      background: linear-gradient(180deg, #0e3671 0%, #2571b5 100%);
      z-index: 9;
      // background-image: url(../assets/static/menuBG.png);
    }
  }

  .shop_user {
    width: 13%;
    display: flex;
    justify-content: end;
    align-items: center;
    margin-right: 24px;
    font-weight: 400;
    font-size: 20px;
    color: #ffffff;
    .user_left {
      width: 24px;
    }
  }
}
// 弹窗样式
:deep(.el-dialog) {
  margin-top: 5vh !important;
}
.el-dialog__body {
  background: #213456;
}
:deep(.el-dialog__header) {
  background: #213456;
  font-weight: bold;
  .el-dialog__title {
    font-size: 20px;
    color: #d4e6ff;
  }
}
:deep(.el-dialog__headerbtn .el-dialog__close) {
  background: linear-gradient(178deg, #0e3671 0%, #174486 100%);
}
:deep(.custom_class) {
  margin-top: 18vh !important;
  background: #ffffff !important;
  .registert_title {
    font-size: 26px;
    text-align: center;
    margin-bottom: 36px;
  }

  .el-dialog__header {
    background: #ffffff;
  }
}
.video_replay {
  width: 100%;
  height: 80%;
  overflow-y: scroll;
  display: flex;
  flex-wrap: wrap;
  .video_name {
    background: #29456e;
    font-size: 18px;
    color: #ffffff;
    padding: 6px;
  }
  .monitor_function {
    display: flex;
    align-content: center;
    justify-content: space-between;
    align-items: center;
    height: 48px;
    background: #29456e;
    font-size: 18px;
    color: #ffffff;
    padding: 0 20px;
  }
  .no_monitor {
    background: #0d264b;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    color: #ffffff;
    // margin-bottom: 10px;
    // margin-right: 10px;
  }
}
</style>
